<template>
  <div class="page-wrapper">
    <div style="float: left">
      <ButtonGroup vertical>
        <Button v-for="(item,index) in typeList" :class="{'btn-primary1':type===item.value}" @click.stop="clickType(item.value)" :key="'keyA'+index">
          {{item.text}}
        </Button>
      </ButtonGroup>
    </div>
    <div class="content-right" v-if="dataList.length>0">
      <template v-for="(item,index) in dataList">
        <div class="fileItem">
          <div style="margin-bottom: 10px">
            <!--<a :href="item.attachmentImgUrl"><img class="file-img" :src="item.attachmentImgUrl"/></a>-->
            <img v-if="item.isImg" @click.stop="showImg(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl" alt="">
            <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>
          </div>
          <div>{{item.attachmentName}}</div>
        </div>
      </template>

    </div>
    <div v-else style="text-align: center;padding-top: 100px">
      <img :src="noprojectinfo" alt="" >
    </div>

  </div>

</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import filedefault from '../../../../../assets/filedefault.jpg';
  import ImgShow from 'components/ImgShow/index'
  import {getProjectInfoType, getProjectInfoByProjectIdAndType} from "../../../../../api/project";
  import {getBaseUrl, checkImgByUrl} from "../../../../../utils/public";
  import {getToken} from '@/utils/auth';
  import noprojectinfo from '../../../../../assets/noprojectinfo.jpg'


  export default {
    // name: "InfoUpdate",
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    components: {
      SaveAndCancel,
      ImgShow
    },
    data() {
      return {
        target: '',
        // imgtest: testing,
        type: '',
        typeList: [],
        baseUrl: '',
        token: '',
        dataList: [],
        defaultImg: filedefault,
        noprojectinfo:noprojectinfo,
      }
    },
    methods: {
      getProjectInfoByProjectIdAndType() {
        let params = {
          projectFid: this.projectFid,
          type: this.type
        }
        getProjectInfoByProjectIdAndType(params).then(res => {
          if(!res.data.attachmentList || res.data.attachmentList.length===0){
            return
          }
          res.data.attachmentList.forEach(ele => {
            ele.isImg = checkImgByUrl(ele.attachmentImgUrl)
          })
          this.dataList = res.data.attachmentList
        })

      },
      clickType(value) {
        if (this.type == value) {
          return
        }
        this.dataList=[]
        this.type = value
        this.getProjectInfoByProjectIdAndType()
      },
      showImg(src) {
        this.$emit('showimg', src)
      },
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()

      getProjectInfoType().then(res => {
        this.typeList = res.data.projectInfoType
        if (this.typeList.length > 0) {
          this.type = this.typeList[0].value
          this.getProjectInfoByProjectIdAndType()
        }
        // console.log(res)
      })
    }
  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 200px;
    height: 130px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 130px;
  }

  .fileItem {
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    flex-wrap: wrap;

  }

  .file-img {
    width: 200px;
    height: 130px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 200px;
  }
  .page-wrapper{
    padding-top: 0;
  }


</style>
